export default __webpack_public_path__ + "static/media/mykonos.17813045.png";